exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-progress-linear[data-v-45dd16a4]{margin:.2rem 0}", ""]);

// exports
